export function trimmed(value: unknown): string {
  return value != null ? String(value).trim() : '';
}
